<div class="p-grid w-100 d-flex justify-content-between">
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'clock']"></fa-icon>
				</span>
				<span class="overview-title">Response Time</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">{{ averageResponseTime }} minutes</div>
					<div class="overview-subtext">Average Response Time</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'bullhorn']"></fa-icon>
				</span>
				<span class="overview-title">Responses</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">{{ surveyService.surveyResponseList.value.length }}</div>
					<div class="overview-subtext">Total Customer Responses</div>
				</div>
			</div>
		</div>
	</div>
	<div class="p-col-12 p-md-6 p-lg-4">
		<div class="card no-gutter widget-overview-box widget-overview-box-1">
			<div class="d-flex">
				<span class="overview-icon">
					<fa-icon [icon]="['far', 'gift-card']"></fa-icon>
				</span>
				<span class="overview-title">Gift Cards</span>
			</div>
			<div class="p-grid overview-detail">
				<div class="p-col">
					<div class="overview-number">{{ giftCardTotal | currency }}</div>
					<div class="overview-subtext">Total Gift Cards Provided to Respondents</div>
				</div>
			</div>
		</div>
	</div>
</div>
